/* ETHEM tema — küçük etkileşimler (bağımlılıksız) */
(function () {
  // Mobil menü
  var btn = document.querySelector('[data-mobil-menu-btn]');
  var menu = document.querySelector('[data-mobil-menu]');
  if (btn && menu) {
    btn.addEventListener('click', function () {
      menu.classList.toggle('acik');
      btn.setAttribute('aria-expanded', menu.classList.contains('acik') ? 'true' : 'false');
    });
  }

  // Ürün sayfası: varyant seçimi → fiyat/buton/URL güncelle
  document.querySelectorAll('[data-varyant-secici]').forEach(function (form) {
    var veriEl = document.getElementById(form.dataset.varyantSecici);
    if (!veriEl) return;
    var varyantlar = JSON.parse(veriEl.textContent);
    form.addEventListener('change', function () {
      var secili = Array.from(form.querySelectorAll('select, input[type="radio"]:checked'))
        .map(function (el) { return el.value; });
      var eslesen = varyantlar.find(function (v) {
        return v.options.every(function (o, i) { return o === secili[i]; });
      });
      var fiyatEl = document.querySelector('[data-urun-fiyat]');
      var butonEl = document.querySelector('[data-sepete-ekle]');
      var idEl = document.querySelector('[data-varyant-id]');
      if (!eslesen) {
        if (butonEl) { butonEl.disabled = true; butonEl.textContent = 'Bu kombinasyon yok'; }
        return;
      }
      if (idEl) idEl.value = eslesen.id;
      if (fiyatEl && eslesen.price_html) fiyatEl.innerHTML = eslesen.price_html;
      if (butonEl) {
        butonEl.disabled = !eslesen.available;
        butonEl.textContent = eslesen.available ? butonEl.dataset.metinEkle : 'Tükendi';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', eslesen.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  // Sepet: adet değişince formu gönder
  document.querySelectorAll('[data-sepet-adet]').forEach(function (input) {
    input.addEventListener('change', function () {
      var f = input.closest('form');
      if (f) f.submit();
    });
  });
})();
